import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import withMatch from '@/hocs/withMatch';

// Services
import withApiData from '../../services/withApiData';
import formatPrice from '../../services/formatPrice';

// Components
import BBCode from '../shared/richText/BBCode';
import ButtonDownload from '../shared/buttons/ButtonDownload';
import ExternalSeller from '../molecules/ExternalSeller';
import PriceStructure from '../PriceStructure';

// Styles
import { colorPalette, shadows, textStyles } from '../../styles/styleGuide';
import { toBreakpoint, fromBreakpoint } from '../../styles/breakpoints';
var connectApiData = withApiData({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    },
    options: {
      cache: "disabled"
    }
  };
});
var ProductOptionStatusModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionStatusModal() {
    var _this;
    _classCallCheck(this, ProductOptionStatusModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductOptionStatusModal, [].concat(args));
    _defineProperty(_this, "transformLastUpdateDate", function (date) {
      var dateParts = date.split(/-| /);
      return "(".concat(dateParts[2], "-").concat(dateParts[1], "-").concat(dateParts[0], ")");
    });
    return _this;
  }
  _inherits(ProductOptionStatusModal, _PureComponent);
  return _createClass(ProductOptionStatusModal, [{
    key: "render",
    value: function render() {
      var orderDetails = this.props.orderDetails;
      var data = orderDetails.data;
      var updateDate = data && this.transformLastUpdateDate(data.lastUpdate);
      return data && orderDetails.request.networkStatus !== 'loading' ? __jsx(Container, {
        "data-id": "homestudio_ProductOptionStatusModal_Container"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionStatusModal_Content"
      }, __jsx(Title, {
        "data-id": "homestudio_ProductOptionStatusModal_Title"
      }, "Orderstatus informatie"), __jsx(Section, {
        "data-id": "homestudio_ProductOptionStatusModal_Section"
      }, __jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SectionTitle"
      }, "Optiespecificatie"), __jsx(OptionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionTitle"
      }, data.option.title), __jsx(OptionBase, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionBase"
      }, data.option.optionCode && __jsx(OptionCode, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), data.option.external_seller && __jsx(ExternalSeller, {
        text: data.option.external_seller,
        "data-id": "homestudio_ProductOptionStatusModal_ExternalSeller"
      })), __jsx(OptionDescription, {
        "data-id": "homestudio_ProductOptionStatusModal_OptionDescription"
      }, __jsx(BBCode, {
        content: data.option.text,
        "data-id": "homestudio_ProductOptionStatusModal_BBCode"
      })), data.option.externalFiles && data.option.externalFiles.length > 0 && __jsx(Fragment, null, __jsx(SubSectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SubSectionTitle"
      }, "Bijlagen"), __jsx(DownloadContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_DownloadContainer"
      }, data.option.externalFiles.map(function (file) {
        return __jsx(ButtonDownload, {
          key: "bijlagen-".concat(file.name),
          content: file.name,
          link: file.url,
          "data-id": "homestudio_ProductOptionStatusModal_ButtonDownload"
        });
      })))), __jsx(Section, {
        withTopBorder: true,
        "data-id": "homestudio_ProductOptionStatusModal_Section"
      }, __jsx(SectionTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_SectionTitle"
      }, "Orderstatus"), __jsx(OrderStatus, {
        color: colorPalette.green,
        "data-id": "homestudio_ProductOptionStatusModal_OrderStatus"
      }, data.placeDescription, " ", updateDate), __jsx(PriceStructure, {
        priceStructure: data.option.priceStructure,
        totalPrice: data.option.price,
        "data-id": "homestudio_ProductOptionStatusModal_PriceStructure"
      }), __jsx(PriceAmountContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountContainer"
      }, data.amount > 1 && __jsx(Fragment, null, __jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountTitle"
      }, "Optie aantal"), __jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountLabel"
      }, data.amount, " (\xE1", ' ', formatPrice(data.salesPrice, {
        showDecimal: true,
        showEuroSign: true
      }), " per stuk)")), __jsx(PriceAmountTitle, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountTitle"
      }, "Totaal bedrag"), __jsx(PriceAmountLabel, {
        "data-id": "homestudio_ProductOptionStatusModal_PriceAmountLabel"
      }, formatPrice(data.salesPrice * data.amount, {
        showDecimal: true,
        showEuroSign: true
      }))), data.document && __jsx(DownloadContainer, {
        "data-id": "homestudio_ProductOptionStatusModal_DownloadContainer"
      }, __jsx(ButtonDownload, {
        content: data.document.name,
        link: data.document.url,
        "data-id": "homestudio_ProductOptionStatusModal_ButtonDownload"
      }))))) : null;
    }
  }]);
}(PureComponent);
export default withMatch(connectApiData(connect(null, null)(ProductOptionStatusModal)));
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), colorPalette.white, shadows.boxPrimary, textStyles.bodyText);
var Content = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: 100rem 20rem;\n  "]))));
var Title = styled.h2(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.pageTitle, colorPalette.headerGrey);
var Section = styled.section(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-top: 40rem;\n  ", ";\n"])), function (props) {
  return props.withTopBorder && "padding-top: 32px; border-top: 1px solid ".concat(colorPalette.background, ";");
});
var SectionTitle = styled.h4(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  letter-spacing: 0.5rem;\n  font-weight: bold;\n  text-transform: uppercase;\n  color: ", ";\n  margin: 0 0 12rem;\n"])), textStyles.caption, colorPalette.orange);
var SubSectionTitle = styled.h5(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin: 0 0 12rem;\n"])), textStyles.title, colorPalette.headerGrey);
var OptionTitle = styled.h3(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n\n  ", ";\n"])), textStyles.sectionTitle, colorPalette.headerGrey, toBreakpoint.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    font-size: 24rem;\n  "]))));
var OptionCode = styled.span(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  margin: 0 0;\n"])), textStyles.caption, colorPalette.beige);
var OptionDescription = styled.div(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  margin-top: 24rem;\n"])));
var DownloadContainer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin: 16rem 0 40rem;\n"])));
var OrderStatus = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  font-style: italic;\n  color: ", ";\n"])), textStyles.title, function (props) {
  return props.color;
});
var PriceAmountContainer = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-top: 40rem;\n"])));
var PriceAmountTitle = styled.h4(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  ", ";\n  margin: 0 0 8rem;\n"])), textStyles.subTitle);
var PriceAmountLabel = styled.span(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  display: block;\n\n  &:first-of-type {\n    margin-bottom: 32rem;\n  }\n"])));
var OptionBase = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 1rem;\n"])));